<!--菜单栏  -->
<template>
    <el-header style="height: 75px">
        <div style="width: 100%; height: 100%">
            <div :class="{ header: true }" ref="headerRef">
                <div class="logo-and-menu">
                    <el-image :src="icon_logo" @click="goHome()"></el-image>
                    <div
                        class="icon-move icon-move-left"
                        v-if="curCanScrollPage && curScrollPage !== 0"
                        @click="handleMenuScroll('left')"
                    >
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div class="header_menu_wrapper">
                        <el-menu
                            background-color="#f1f3f6"
                            mode="horizontal"
                            active-text-color="#409EFF"
                            router
                            :default-active="activeMenu"
                            class="page_header_menu"
                            ref="pageHeaderMenu"
                            :style="{ maxWidth: curMenuWidth + 'px' }"
                        >
                            <div
                                :class="{
                                    menu_item_wrapper: true,
                                    menu_item_wrapper_sh_manifest:
                                        route.name === 'sh_manifest',
                                    menu_item_wrapper_toker:
                                        route.name === 'Toker',
                                }"
                                v-for="route in showMenus"
                            >
                                <MenuTip
                                    title="专注运踪更清晰"
                                    class="menu_item_tooltip Abroad"
                                    v-if="route.name === 'Abroad'"
                                ></MenuTip>
                                <MenuTip
                                    class="menu_item_tooltip freightOfLegends"
                                    title="找同行、资源共享"
                                    v-if="route.name === 'FreightOfLegendsMenu'"
                                ></MenuTip>
                                <MenuTip
                                    class="menu_item_tooltip Pre9810"
                                    title="9810/9710 订单推送"
                                    v-if="route.name === 'Pre9810'"
                                ></MenuTip>
                                <MenuTip
                                    class="menu_item_tooltip classAnalysis"
                                    title="智能归类,品牌查询,美国HS对华加征"
                                    v-if="route.name === 'ClassAnalysisMenu'"
                                    color="#409eff"
                                ></MenuTip>
                                <MenuTip
                                    class="menu_item_tooltip smartManifest"
                                    title="AI智能识别"
                                    v-if="route.name === 'SmartManifest'"
                                    color="#409eff"
                                ></MenuTip>
                                <menu-item
                                    :key="route.path"
                                    :item="route"
                                    :base-path="route.path"
                                ></menu-item>
                            </div>
                        </el-menu>
                    </div>
                </div>
                <div
                    class="icon-move icon-move-right"
                    v-if="curScrollPage < curCanScrollPage"
                    @click="handleMenuScroll('right')"
                >
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="user_div-f">
                    <DropDownMenu
                        @openNoteDialog="$refs.noteDialog.open()"
                    ></DropDownMenu>
                </div>
            </div>
            <div
                v-if="needSwiperElement"
                class="header-swiper"
                :style="{ visibility: showHeaderSwiper ? 'visible' : 'hidden' }"
            >
                <RecentSubscribeSwiper></RecentSubscribeSwiper>
            </div>
        </div>
        <login-dialog
            v-if="loginDialogVisible"
            ref="LoginDialog"
        ></login-dialog>
        <TimeLineNoteDialog v-if="!loginDialogVisible" ref="noteDialog" />
        <OpenAds ref="openAdsRef" v-if="!loginDialogVisible" />
    </el-header>
</template>

<script>
import RecentSubscribeSwiper from "@/components/common/RecentSubscribeSwiper.vue";
import MenuItem from "./MenuItem.vue";
import { getToken } from "@/utils/auth";
import LoginDialog from "@/components/register/WechatLoginDialog";
import { getUserAccountInfo, apiCallback } from "@/utils";
import DropDownMenu from "./DropDownMenu.vue";
import TimeLineNoteDialog from "@/components/update-notes/timeline-note.vue";
import LogoutDialog from "@/components/register/LogoutDialog";
import SwitchIdDialog from "@/components/register/SwitchIdDialog";
import MenuTip from "@/components/common/MenuTip.vue";
import { mapGetters } from "vuex";
import bus from "@/utils/bus.js";
import AppLink from "./Link";
import { payRate } from "@/utils/pay-data-list";
import OpenAds from "@/components/open-ads/index.vue";
import { NOT_INIT_ADS } from "@/components/open-ads/constants";
export default {
    components: {
        MenuItem,
        AppLink,
        LoginDialog,
        DropDownMenu,
        LogoutDialog,
        SwitchIdDialog,
        MenuTip,
        TimeLineNoteDialog,
        OpenAds,
        RecentSubscribeSwiper,
    },
    mounted() {
        this.init();
        window.addEventListener("pagehide", this.unloadHandler);
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("pagehide", this.unloadHandler);
        window.removeEventListener("scroll", this.handleScroll);
    },
    data() {
        return {
            getToken: getToken,
            icon_logo: require("@/assets/img/logo.png"),
            BoxQueryMenuTooltip: require("@/assets/icon/box_query_menu_tooltip.svg"),
            ShipSubscribMenuTooltip: require("@/assets/icon/shipSubscrib_menu_tooltip.svg"),
            AnalysisMenuTooltip: require("@/assets/icon/analysis_menu_tooltip.svg"),
            AnalysisMenu: require("@/assets/icon/analysis_menu.svg"),
            OptuserInfo: [
                {
                    label: "用户中心",
                    command: "user_center",
                },
                {
                    label: "企业认证",
                    command: "company_certify",
                },
                {
                    label: "切换身份",
                    command: "switch_role",
                },
                {
                    label: "退出",
                    command: "quit",
                },
            ],
            loginDialogVisible: false,
            logoutDialogVisible: false,
            switchIdDialogVisible: false,
            payRate,
            // 当前屏幕尺寸
            curWindowWidth: window.innerWidth,
            // 当前menu应该有的宽度
            curMenuWidth: 0,
            // 真实的菜单栏宽度
            trulyMenuWidth: 0,
            // 当前菜单滚动到第几页了
            curScrollPage: 0,
            showHeaderSwiper: true, // 是否显示头部swiper(滚动条置顶时显示)
            showSwiperPageNameArr: [
                "/logistics",
                "/shipSubscrib",
                "/boxquery",
                "/manifestQuery",
                "/classAnalysis",
                "/abroad",
            ], // 需要显示头部swiper的页面
            needSwiperElement: true, // 是否需要渲染头部swiper
        };
    },
    computed: {
        ...mapGetters(["menu_routes", "token", "loginId"]),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        showMenus() {
            return this.menu_routes.filter((item) => !item.meta?.hidden);
        },
        //  当前能够滚动的页数
        curCanScrollPage() {
            if (this.curMenuWidth) {
                // 当前藏的部分
                const hideWidth = this.trulyMenuWidth - this.curMenuWidth;
                // 允许一点误差
                if (hideWidth < 20) {
                    return 0;
                }
                // 藏的部分除以显示部分的倍数
                return Math.ceil(hideWidth / this.curMenuWidth);
            }
            return 0;
        },
    },
    watch: {
        activeMenu(val) {
            if (val.indexOf("fileAnalysis") !== -1) {
                bus.$emit("goFileAnalysisPage");
            }
            this.handleAdsShow();
            this.handleShowHeaderSwiper();
        },
    },
    methods: {
        handleAdsShow() {
            // 拿store中的值
            const isAdsLook = this.$store.state.other.isLookAds;
            if (isAdsLook) {
                return;
            }
            const fullRouterPath = this.$router.currentRoute.fullPath;
            if (
                this.$refs.openAdsRef &&
                [
                    "/logistics",
                    "/shipSubscrib",
                    "/boxquery",
                    "/manifestQuery",
                    "/classAnalysis",
                    "/shipSchedule",
                    "/abroad"
                ].includes(fullRouterPath)
            ) {
                this.$refs.openAdsRef.open();
            }
            this.$store.commit("other/setLookAds", true);
        },
        handleShowHeaderSwiper() {
            const fullRouterPath = this.$router.currentRoute.fullPath;
            if (this.showSwiperPageNameArr.includes(fullRouterPath)) {
                this.needSwiperElement = true;
            } else {
                this.needSwiperElement = false;
            }
        },
        goHome() {
            if (this.$router.currentRoute.fullPath != "/home") {
                this.$router.push("/");
            } else {
                this.$router.go(0);
            }
        },
        initMenu() {
            // 初始化菜单栏
            this.curMenuWidth = 0;
            // 当前滚动到第几页
            this.curScrollPage = 0;
            const menuDom = this.$refs.pageHeaderMenu.$el;
            // 重置滚动举例
            menuDom.style.transform = `translateX(0px)`;
            this.curWindowWidth = this.$refs.headerRef.offsetWidth;
            this.$nextTick(() => {
                // 图片有个margin-left:20px
                // 然后logo图片的宽度 el-image， document.querySelector('.logo-and-menu .el-image').offsetWidth
                // 右侧有个user_div-f的宽度， document.querySelector('.user_div-f').offsetWidth
                // 再预留一点宽度 100
                const preWidth = 100;
                // 需要减去的宽度
                const needWidth = 20 + preWidth;
                const menuWidth =
                    this.curWindowWidth -
                    needWidth -
                    document.querySelector(".logo-and-menu .el-image")
                        .offsetWidth -
                    document.querySelector(".user_div-f").offsetWidth;
                this.curMenuWidth = menuWidth;
                menuDom.style.maxWidth = `${menuWidth}px`;
            });
        },
        calTrulyMenuWidth() {
            this.trulyMenuWidth = 0;
            this.$nextTick(() => {
                const domArr = document.querySelectorAll(
                    ".page_header_menu .menu_item_wrapper",
                );
                domArr.forEach((item) => {
                    this.trulyMenuWidth += item.offsetWidth;
                });
            });
        },
        init() {
            // 初始化menu信息
            this.initMenu();
            // 计算真实的menu-tab需要的宽度
            this.calTrulyMenuWidth();
            // 检测窗口变化
            window.addEventListener("resize", this.initMenu);
            this.$store.commit("other/setLookAds", false);
            if (!getToken()) {
                this.login();
            } else {
                this.handleShowHeaderSwiper();
                const fullRouterPath = this.$router.currentRoute.fullPath;
                this.handleShowHeaderSwiper();
                // 避免重复请求取消导致不生效
                if (fullRouterPath == "/pay/charge") {
                    return;
                }
                // 请求余额数据
                getUserAccountInfo();
                this.handleAdsShow();
            }
        },
        //登录，显示二维码弹窗
        login() {
            this.loginDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.LoginDialog.init();
            });
        },
        // 控制菜单栏滚动
        handleMenuScroll(type) {
            // 每一次移动的距离(实际menu的长度-当前menu的长度)/当前能够滚动的页数
            const eachMove =
                (this.trulyMenuWidth - this.curMenuWidth) /
                this.curCanScrollPage;
            const menuDom = this.$refs.pageHeaderMenu.$el;
            if (type === "left") {
                this.curScrollPage--;
            } else if (type === "right") {
                this.curScrollPage++;
            }
            menuDom.style.transform = `translateX(${
                -this.curScrollPage * eachMove
            }px)`;
        },
        handleScroll() {
            // 兼容性写法
            const scrollTop =
                window.scrollY ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            this.showHeaderSwiper = scrollTop === 0;
        },
        unloadHandler() {
            this.$store.commit("ship/editBlonBoxInfo", []);
            this.$store.commit("ship/editShipInfo", []);
            this.$store.commit("ship/editDockInfo", []);
            this.$store.commit("ship/editAllBoxInfo", []);
            this.$store.commit("ship/editBoxStatus", []);
            this.$store.commit("ship/editShipStatus", []);
        },
    },
};
</script>

<style scoped lang="stylus">
.header-swiper{
    position: absolute;
    top: 75px;
    left: 0;
    width: 100%;
    height: auto;
}

.header{
    display:flex;
    width:100%;
    height:100%;
    justify-content: space-between;
}
.header_menu_wrapper{
    height:100%;
    display:flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: hidden;
}
.el-header {
  background-color: #f1f3f6;
  color: #333;
  box-shadow: 10px 10px 18px rgba(55, 84, 170, 0.15);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
  position: fixed;
  width: 100%;
  top: 0;
  padding: 0;
}

@media (max-width: 1450px) {
  .logo-and-menu{
    margin: 0 8px !important;
  }

  .el-header{
    padding-left: 0;
  }
}



.el-menu {
  &.page_header_menu{
    display: flex;
    border-bottom: none;
    margin-left: 16px;
    transition: transform 1s ease-in-out;
    .el-menu--horizontal {
      border-bottom: 0px;
    }
    .menu_item_wrapper{
      position:relative;
    }
    .menu_item_tooltip{
        position:absolute;
        top:0px;
        transform:translateY(-80%);
        z-index:999;
        &.Toker{
            left: 50%;
        }
        &.shipSchedule{
            left: 40%;
        }
        &.shipSubscrib{
            left: 55%;
        }
        &.freightOfLegends{
            left:40%;
        }
        &.Abroad{
            left:45%;
        }
        &.classAnalysis{
            left: 30%;
        }
        &.Pre9810{
            left:30%;
        }
        &.smartManifest{
            left: 50%;
        }
    }
  }
}
.logo-and-menu {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  width: fit-content;
  margin-left: 20px;
  padding-bottom: 4px;
  .menu_item_wrapper .el-image{
    width: 90px;
    height: 28px;
    object-fit: cover;
  }

  .el-image {
    object-fit: cover;
    height: 40px ;
    width: 98px ;
    padding-bottom: 8px;
  }
}

.user_div-f {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-left:8px;
}

.icon-move{
   width:20px;
   height: 100%;
   padding-top: 8px;
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   cursor:pointer;
   color:#68020f;
   margin: 0 10px;
   &:hover{
    background-color: #d3d3d3;
   }
   i{
    font-size: 20px;
    color:#68020f;
    font-weight: bold;
   }
}
</style>
